import { gql } from '@apollo/client';

export const CREATE_HEALTH_CHECKUP_INSTITUTION = gql`
  mutation createHealthCheckupInstitution($input: CreateHealthCheckupInstitutionInput!) {
    createHealthCheckupInstitution(input: $input) {
      healthCheckupInstitution {
        id
      }
    }
  }
`;

export interface CreateHealthCheckupInstitutionQueryVariables {
  input: {
    healthCheckupInstitutionId: string;
    name: string;
    location: string;
  };
}
